import comp from "./Standards";
export default comp;
